var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { axios } from "../Support/axios";
import { HttpFormError } from "../Support/HttpFormError";
var AccountSettings = (function (_super) {
    __extends(AccountSettings, _super);
    function AccountSettings(accountId, data) {
        var _this = _super.call(this) || this;
        _this.showConfirmationModal = false;
        _this.data = false;
        _this.dataCache = false;
        _this.accountId = accountId;
        _this.data = data;
        _this.updateDataCache();
        return _this;
    }
    AccountSettings.prototype.updateDataCache = function () {
        this.dataCache = Object.assign({}, this.data);
    };
    AccountSettings.prototype.resetDataCache = function () {
        this.data = Object.assign({}, this.dataCache);
    };
    AccountSettings.prototype.cancelModal = function () {
        this.resetDataCache();
        this.showConfirmationModal = false;
    };
    AccountSettings.prototype.toggleConfirmationModal = function () {
        this.showConfirmationModal = !this.showConfirmationModal;
    };
    AccountSettings.prototype.updateAccountSettings = function () {
        var _this = this;
        var url = '/api/account/' + this.accountId;
        return axios.patch(url, this.data).then(function () {
            _this.updateDataCache();
            _this.toggleConfirmationModal();
        }).catch(function (e) {
            _this.cancelModal();
            _this.setError(e);
        });
    };
    AccountSettings.prototype.updateAccountCostIndex = function () {
        var _this = this;
        var url = '/api/account/' + this.accountId + '/cost-index/update';
        return axios.patch(url, this.data).then(function () { return _this.updateDataCache(); }).catch(function (e) {
            _this.cancelModal();
            _this.setError(e);
        });
    };
    return AccountSettings;
}(HttpFormError));
export { AccountSettings };
